import { render, staticRenderFns } from "./LanguageAlertModal.vue?vue&type=template&id=15261d3e&"
import script from "./LanguageAlertModal.vue?vue&type=script&lang=js&"
export * from "./LanguageAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./LanguageAlertModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports